import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { doCreatePricing, doGetPricing, doUpdatePricing, doDeletePricing } from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('pricing/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('pricing/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('pricing/') && action.type.endsWith('/rejected');
};

const pricingAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const pricingSlice = createSlice({
  name: 'pricing',
  initialState: {
    action: null,
    isFetching: false,
    status: 'idle',
    metadata: {},
    entities: [],
    ids: [],
    item: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetPricing.pending, (state) => {
      state.action = 'getall';
      state.status = 'loading';
      state.isFetching = true;
      state.metadata = {};
      pricingAdapter.removeAll(state);
    });
    builder.addCase(doGetPricing.fulfilled, (state, action) => {
      const pricings = Object.keys(action.payload).map((key) => {
        const pricing = action.payload[key];
        const transformedPricingRanges = pricing.pricingRanges.reduce((result, range) => {
          const { orderType, minOrders, maxOrders, price, id } = range;
          if (!result[orderType]) {
            result[orderType] = [];
          }
          result[orderType].push({ minOrders, maxOrders, price, id });
          return result;
        }, {});
        return { ...pricing, pricingRanges: transformedPricingRanges };
      });
      state.status = 'succeeded';
      state.metadata = action.payload.meta;
      pricingAdapter.setAll(state, pricings);
    });
    builder.addCase(doGetPricing.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreatePricing.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreatePricing.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doCreatePricing.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdatePricing.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdatePricing.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdatePricing.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doDeletePricing.fulfilled, (state, action) => {
      pricingAdapter.removeOne(state, action.meta.arg);
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const {
  selectAll: selectAllPricing,
  selectById: selectPricingById,
  selectIds: selectPricingIds,
} = pricingAdapter.getSelectors((state) => state.pricing);

const { reducer: pricingReducer } = pricingSlice;
export default pricingReducer;
